import React from 'react';
import PropTypes from 'prop-types';
import EnhancedRaisedButton from './EnhancedRaisedButton';
import translate from 'components/hoc/translate';

const SubmitButton = (props) => {
    const {
        disabled,
        loading,
        primary,
        translate,
    } = props;

    return (
        <EnhancedRaisedButton
            disabled={ disabled }
            label={ translate('actions.submit') }
            loading={ loading }
            primary={ primary }
            type='submit'
        />
    );
};

SubmitButton.defaultProps = {
    disabled: false,
    loading: false,
    primary: true,
};

SubmitButton.propTypes = {
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    primary: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default translate(SubmitButton);



// WEBPACK FOOTER //
// ./src/components/button/SubmitButton.js